import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function ContractNumberField(props) {
    return (
        <FormikInput
            name={'contractNumber'}
            label={'shippingMethods.form.field.contractNumber.label'}
            placeholder={'shippingMethods.form.field.contractNumber.placeholder'}
            required={true}
        />
    );
}

export default ContractNumberField;
